import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import CommentList from '../../Components/Commons/CommentList'
import ReadList from '../../Components/Commons/ReadList'
import { Link, withRouter } from 'react-router-dom'
import ReportDetail from '../../Components/Report/ReportDetail'
import './ReportDetailPage.scss'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import ReactGA from 'react-ga'
import moment from 'moment'
import { RoleStr, getThumbnailSVG } from '../../Components/Commons/Utils'

const TagItem = ({ item }) => {
    return <li>#{item}</li>
}

class ReportDetailPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            report: null,
            user: {
                _id: '',
            },
            deletePop: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
        this.loadReport()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadReport = () => {
        const { cookies } = this.props
        axios
            .get(`${BACKEND_HOST}/reports/${this.props.match.params.id}?project_id=${cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ report: res.data })
            })
            .catch((e) => {
                if (e?.response?.data?.statusCode === 403) {
                    alert('페이지 권한이 없습니다.')
                    this.props.history.replace('/')
                }

                if (e?.response?.data?.statusCode === 404) {
                    alert('존재하지 않는 페이지 입니다.')
                    this.props.history.replace('/')
                }
            })
    }

    onDelete = () => {
        const reportId = this?.state?.report?._id
        axios
            .delete(`${BACKEND_HOST}/reports/${reportId}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                ReactGA.event({ category: '작업보고', action: '삭제' })
                this.props.history.goBack()
            })
            .catch((err) => {
                this.props.history.goBack()
            })
    }

    renderTag = () => {
        const List = this.state.report.tags.map((list) => {
            return <TagItem item={list.keyword} key={list._id} />
        })
        return List
    }

    render() {
        if (this.state.report) {
            //날짜 변환
            const newDate = new Date(this.state.report.createdAt)
            const newYear = newDate.getFullYear()
            const week = new Array('일', '월', '화', '수', '목', '금', '토')
            const newDayName = week[newDate.getDay()]

            let newMonth = newDate.getMonth() + 1
            if (newMonth < 10) {
                newMonth = '0' + newMonth
            }
            let newDay = newDate.getDate()
            if (newDay < 10) {
                newDay = '0' + newDay
            }
            let newHours = newDate.getHours()
            if (newHours < 10) {
                newHours = '0' + newHours
            }
            let newMinutes = newDate.getMinutes()
            if (newMinutes < 10) {
                newMinutes = '0' + newMinutes
            }

            let thumbnail = ''
            if (this.state.report.writer && this.state.report.writer.thumbnailUrl) {
                thumbnail = <img src={this.state.report.writer.thumbnailUrl} alt="profile" />
            } else {
                thumbnail = getThumbnailSVG(this.state.report.writer.group, 36)
            }

            return (
                <div>
                    {this.state.deletePop && (
                        <div className="alret_pop2_bg">
                            <div className="alret_pop2_wrap">
                                <p className="h1_text">삭제하시겠습니까?</p>
                                <p>삭제하면 복원할 수 없습니다.</p>
                                <div className="btn btn1" onClick={() => this.setState({ deletePop: false })}>
                                    아니오
                                </div>
                                <div className="btn btn2" onClick={() => this.onDelete()}>
                                    네
                                </div>
                            </div>
                        </div>
                    )}

                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div className="report_detail_wrap common_detail">
                            <div className="section">
                                <div className="page_name">작업보고</div>
                                <div className="top_writer_wrap">
                                    <div className="writer_profile">{thumbnail}</div>
                                    <div>
                                        <p className="writer_name">
                                            {RoleStr[this.state.report.writer.group]} {this.state.report.writer.name}
                                        </p>
                                        <ul className="write_date">
                                            <li>
                                                {newYear}.{newMonth}.{newDay} ({newDayName})
                                            </li>
                                            <li className="line" />
                                            <li>
                                                {newHours}:{newMinutes}
                                            </li>
                                            <li className="line" />
                                            <li>
                                                <div className="view_count">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="14"
                                                        height="10"
                                                        viewBox="0 0 14 10">
                                                        <g fill="#D9DCE2" fillRule="evenodd">
                                                            <path d="M13.9 4.542C11.72 1.46 9.365-.078 6.9.003 2.914.123.198 4.385.084 4.566a.56.56 0 0 0 .013.61C2.304 8.378 4.64 10 7.047 10c.085 0 .17-.003.256-.007 3.95-.187 6.519-4.668 6.626-4.859a.559.559 0 0 0-.03-.592z" />
                                                            <path
                                                                stroke="#FFF"
                                                                strokeWidth="1.2"
                                                                d="M5 4.95C5 6.08 5.92 7 7.05 7S9.1 6.08 9.1 4.95 8.18 2.9 7.05 2.9 5 3.82 5 4.95z"
                                                            />
                                                        </g>
                                                    </svg>
                                                    {this.state.report.viewCount}
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {this.state.report ? <ReportDetail report={this.state.report} /> : '내용없음'}

                                <div className="tag_btn_wrap">
                                    {/* {this.state.report.tags && this.state.report.tags.length !== 0 && (
                                        <div className="tags_wrap">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="18"
                                                height="12"
                                                viewBox="0 0 18 12">
                                                <path
                                                    fill="#CACFD5"
                                                    fillRule="nonzero"
                                                    d="M1 0h9.574a3 3 0 0 1 1.867.652l4.756 3.783a2 2 0 0 1 0 3.13l-4.756 3.783a3 3 0 0 1-1.867.652H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm10.61 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                                                />
                                            </svg>
                                            <ul>{this.renderTag()}</ul>
                                        </div>
                                    )} */}

                                    {/* {this.state.report.writer_id === this.state.user._id && (
                                        <div className="report_writer_only_menu">
                                            <div
                                                className="report_delete_btn"
                                                onClick={() => this.setState({ deletePop: true })}>
                                                삭제
                                            </div>

                                            <div
                                                className="report_modify_btn"
                                                onClick={() => {
                                                    ReactGA.event({ category: '작업보고', action: '수정' })
                                                    this.props.history.push(`/report/write/${this.state.report._id}`)
                                                }}>
                                                수정
                                            </div>
                                        </div>
                                    )} */}
                                </div>

                                <ReadList readers={this.state.report.readUsers} />

                                <div className={'comment_show'}>
                                    <CommentList
                                        project_id={this.state.report._project}
                                        id={this.props.match.params.id}
                                        page={'report'}
                                        url={'REPORT'}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Link
                                    to={'/report/'}
                                    onClick={() => {
                                        ReactGA.event({ category: '작업보고', action: '목록 이동' })
                                    }}>
                                    <div className="list_btn common_wrap">
                                        목록
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="8"
                                            viewBox="0 0 10 8">
                                            <g
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#6D7075"
                                                strokeLinecap="round"
                                                strokeWidth="1.2">
                                                <path d="M.674 1H9.32M.674 4.06h6.277M.674 7.06h8.65" />
                                            </g>
                                        </svg>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap" />
            </div>
        )
    }
}

export default withCookies(ReportDetailPage)



// WEBPACK FOOTER //
// ./Src/Containers/Report/ReportDetailPage.js